import * as React from "react";

export default function Home(): React.ReactElement {
  return <div>HOME</div>;
}
